import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import _ from 'lodash';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


function ItemGroupMaster(props) {
  const [itemGroups, setItemGroups] = useState([]);
  const [itemGroupCode, setItemGroupCode] = useState('');
  const [itemGroupName, setItemGroupName] = useState('');
  const [itemGroupNameEnglish, setItemGroupNameEnglish] = useState('');
  const [remark1, setRemark1] = useState('');
  const [remark2, setRemark2] = useState('');
  const [userId, setUserId] = useState('');
  const [formMode, setFormMode] = useState('add');
  const [edititemGroupCode, setEdititemGroupCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [itemGroupMasterEntries, setItemGroupMasterEntries] = useState([]);
  // const sortedItemGroups = _.sortBy(itemGroupMasterEntries, 'ItemGroupCode');

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    fetchItemGroupMaster();
  }, []);

  const fetchItemGroupMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/item-groups');
      setItemGroupMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setItemGroupCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.ItemGroupCode > maxEntryNo) {
    maxEntryNo = entry.ItemGroupCode;
  }
  }
  return maxEntryNo;
  };

  const addItemGroup = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/item-groups', {
        ItemGroupCode: itemGroupCode,
        ItemGroupName: itemGroupName,
        ItemGroupNameEnglish: itemGroupNameEnglish,
        Remark1: remark1,
        Remark2: remark2,
        USERID: props.name
      });
      fetchItemGroupMaster();
      setItemGroupCode('');
      setItemGroupName('');
      setItemGroupNameEnglish('');
      setRemark1('');
      setRemark2('');
      setUserId('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateItemGroup = async (itemGroupCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/item-groups/${itemGroupCode}`, {
        ItemGroupCode: itemGroupCode,
        ItemGroupName: itemGroupName,
        ItemGroupNameEnglish: itemGroupNameEnglish,
        Remark1: remark1,
        Remark2: remark2,
        USERID: props.name
      });
      fetchItemGroupMaster();
      setItemGroupCode('');
      setItemGroupName('');
      setItemGroupNameEnglish('');
      setRemark1('');
      setRemark2('');
      setUserId('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  

  const deleteItemGroup = async (ItemGroupCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/item-groups/${ItemGroupCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        fetchItemGroupMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  }; 

  const setEditForm = (itemGroup) => {
    setFormMode('edit');
    setItemGroupCode(itemGroup.ItemGroupCode);
    setItemGroupName(itemGroup.ItemGroupName);
    setItemGroupNameEnglish(itemGroup.ItemGroupNameEnglish);
    setRemark1(itemGroup.Remark1);
    setRemark2(itemGroup.Remark2);
    setUserId(itemGroup.UserId);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = itemGroups.filter((itemGroup) => {
      const itemGroupCode = itemGroup.ItemGroupCode.toString().toLowerCase();
      const itemGroupName = itemGroup.ItemGroupName.toString().toLowerCase();
      const itemGroupNameEnglish = itemGroup.ItemGroupNameEnglish.toString().toLowerCase();
      const remark1 = itemGroup.Remark1.toString().toLowerCase();
      const remark2 = itemGroup.Remark2.toString().toLowerCase();
      const userId = itemGroup.UserId.toString().toLowerCase();

      return (
        itemGroupCode.includes(searchQuery.toLowerCase()) ||
        itemGroupName.includes(searchQuery.toLowerCase()) ||
        itemGroupNameEnglish.includes(searchQuery.toLowerCase()) ||
        remark1.includes(searchQuery.toLowerCase()) ||
        remark2.includes(searchQuery.toLowerCase()) ||
        userId.includes(searchQuery.toLowerCase())
      );
    });

    setItemGroupMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, itemGroups]);

  const handleShowAndHide = () => {
    setShowGrid(!showGrid);
    setItemGroups(itemGroups);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEdititemGroupCode('');
    setItemGroupCode('');
    setItemGroupName('');
    setItemGroupNameEnglish('');
    setRemark1('');
    setRemark2('');
    setUserId('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "ItemGroupData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>ItemGroupMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleShowAndHide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && (
        <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
          >
            Download PDF
          </Button>
        </Grid>
      )}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemGroupCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemGroupCode</label>
            <input
              type="text"
              value={itemGroupCode}
              readOnly
              placeholder="ItemGroupCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemGroupName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemGroupName</label>
            <input
              type="text"
              value={itemGroupName}
              onChange={(e) => setItemGroupName(e.target.value)}
              placeholder="ItemGroupName"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemGroupNameEnglish" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemGroupNameEnglish</label>
            <input
              type="text"
              value={itemGroupNameEnglish}
              onChange={(e) => setItemGroupNameEnglish(e.target.value)}
              placeholder="ItemGroupNameEnglish"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Remark1" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>Remark1</label>
            <input
              type="text"
              value={remark1}
              onChange={(e) => setRemark1(e.target.value)}
              placeholder="Remark1"
              style={{ marginBottom: '5px', padding: '5px', width: '20%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addItemGroup : () => updateItemGroup(itemGroupCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemGroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemGroupName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemGroupNameEnglish
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Remark1
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {itemGroupMasterEntries.map((itemGroup) => (
                <tr key={itemGroup.ItemGroupCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemGroup.ItemGroupCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemGroup.ItemGroupName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemGroup.ItemGroupNameEnglish}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemGroup.Remark1}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(itemGroup)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteItemGroup(itemGroup.ItemGroupCode)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
     
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default ItemGroupMaster;
